import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './style.scss'

import Logo from '../logo'

export default class FullScreenForm extends Component {

    static propTypes = {
        children: PropTypes.object
    }

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className={style.fullScreenForm}>
                <div className={style.logoContainer}>
                    <Logo />
                </div>
                <div className={style.formContent}>
                    {this.props.children}
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// src/components/full-screen-form/index.js